@if (loading) {
<div class="dark-overlay">
  <div class="loading-message">
    <p-progress-spinner styleClass="custom-spinner" strokeWidth="4" ariaLabel="loading" />
    <div>
      {{ message }}
    </div>
  </div>
</div>
}
